import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: 'Is Zesty a pre-workout?',
    answer: 'Zesty can be used before training, but it is built as a daily energy + hydration powder — not a max-stim pre-workout.'
  }, {
    question: 'Is this replacing coffee?',
    answer: 'It can. Zesty is made for people who want the lift and ritual of coffee without the crashy, anxious feeling.'
  }, {
    question: 'How much caffeine is in it?',
    answer: 'Each scoop has 125mg caffeine.'
  }, {
    question: 'When does the first drop launch?',
    answer: 'The first Citrus drop is coming soon. Join the early list to get notified first.'
  }];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-58">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-59">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-headline text-4xl md:text-5xl text-charcoal text-center mb-12" data-id="element-60">
          FAQ
        </motion.h2>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-63">
                <span className="font-semibold text-lg text-charcoal pr-4" data-id="element-64">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-65" />
              </button>

              <AnimatePresence data-id="element-66">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-67">
                    <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-68">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}